/**
 *  Circular list helpers
 */

function next(list, current) {
  let nextItem = list.indexOf(current) + 1;
  if (nextItem === list.length) {
    nextItem = 0;
  }

  return list[nextItem];
}

function prev(list, current) {
  let prevItem = list.indexOf(current) - 1;
  if (prevItem <= -1) {
    prevItem = list.length - 1;
  }

  return list[prevItem];
}

export default {
  next,
  prev,
};
